import { PLAN_BUILDER_URL } from "@/lib/clickthrough-destination";
import type { SectionPriceProductCardsEditableData } from "./types";

export const defaultPriceProductCardsData: SectionPriceProductCardsEditableData =
  {
    elementName: "PriceProductCardsSection",
    title: "Choose the high-power speed you need",
    subtitle: "",
    textAlign: "left",
    hasPeriodPricingToggle: true,
    initialToggleState: "five-year",
    isLocalizable: true,
    cardsToDisplay: "1,2,3,4,5",
    products: [
      {
        speed: "300",
        unit: "Mbps",
        basePrice: 40,
        periodPrice: 45,
        tagline: "Best for everyday life",
        features: [
          "Great for catching up on your email and streaming",
          "Reliable speeds for browsing, streaming, and connecting",
          "Download a 1-hour HD show in about 53 seconds",
        ],
        ctas: [
          {
            copy: "Check availability",
            action: "link",
            url: PLAN_BUILDER_URL,
            oneYearUrl: `${PLAN_BUILDER_URL}?defaultToggle=1yr`,
            fiveYearUrl: PLAN_BUILDER_URL,
            display: "outline",
          },
        ],
      },
      {
        speed: "500",
        unit: "Mbps",
        basePrice: 45,
        periodPrice: 50,
        tagline: "Great for working & learning",
        features: [
          "Perfect for working, video chatting, and learning from home",
          "Supports multiple connected devices with minimal lag",
          "Download a 1-hour HD show in about 32 seconds",
        ],
        ctas: [
          {
            copy: "Check availability",
            action: "link",
            url: PLAN_BUILDER_URL,
            oneYearUrl: `${PLAN_BUILDER_URL}?defaultToggle=1yr`,
            fiveYearUrl: PLAN_BUILDER_URL,
            display: "outline",
          },
        ],
      },
      {
        speed: "1000",
        unit: "Mbps",
        extendedTitle: "1 Gig",
        basePrice: 50,
        periodPrice: 60,
        tagline: "Perfect for streamers & gamers",
        badgeCopy: "Most popular",
        features: [
          "Best for multi-player gaming, video calls, and streaming",
          "Stream in HD and 4K throughout the house",
          "Download a 1-hour HD show in about 16 seconds",
        ],
        ctas: [
          {
            copy: "Check availability",
            action: "link",
            url: PLAN_BUILDER_URL,
            oneYearUrl: `${PLAN_BUILDER_URL}?defaultToggle=1yr`,
            fiveYearUrl: PLAN_BUILDER_URL,
            display: "outline",
          },
        ],
      },
      {
        speed: "1200",
        unit: "Mbps",
        extendedTitle: "1.2 Gig",
        basePrice: 80,
        periodPrice: 85,
        tagline: "Get next-level connection",
        legalDisclaimer: "Available in select areas",
        features: [
          "For ultra-connected households and pro-level gaming",
          "Stream, upload, and share with lightning-fast reliability",
          "Download a 1-hour HD show in about 13 seconds",
        ],
        ctas: [
          {
            copy: "Check availability",
            action: "link",
            url: PLAN_BUILDER_URL,
            oneYearUrl: `${PLAN_BUILDER_URL}?defaultToggle=1yr`,
            fiveYearUrl: PLAN_BUILDER_URL,
            display: "outline",
          },
        ],
      },
      {
        speed: "2000",
        unit: "Mbps",
        extendedTitle: "2 Gig",
        basePrice: 80,
        periodPrice: 85,
        tagline: "For ultimate performance",
        legalDisclaimer: "Available in select areas",
        features: [
          "Superior connection to power hundreds of devices",
          "Supercharge 4K streaming and uploads on every device",
          "Download a 1-hour HD show in about 8 seconds",
        ],
        ctas: [
          {
            copy: "Check availability",
            action: "link",
            url: PLAN_BUILDER_URL,
            oneYearUrl: `${PLAN_BUILDER_URL}?defaultToggle=1yr`,
            fiveYearUrl: PLAN_BUILDER_URL,
            display: "outline",
          },
        ],
      },
    ],
    legalDisclaimer:
      "Offer ends 12/1. New Xfinity Internet customers. Restrictions apply. Autopay w/ stored bank account and paperless billing req’d. Taxes and fees extra and subj. to change.",
  };
